let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5yV3B")).then(() => parcelRequire('F35X1'));